import { defaultSetter } from 'rewire-common';
import { ITimeOffType, TimeOffTypeSort } from '../DataTypes';
import DataQueries from '../graphql/Queries';
import mainPageModel from '../main-navigation/MainPageModel';
import timeoffTypeDialogModel, { TimeOffTypeSchema } from '../schedule/TimeOffTypeDialogModel';
import { MasterDataSettingsModel } from './MasterDataSettingsModel';
import TimeOffTypesEditPanelFormView from './TimeOffTypesEditPanelFormView';

export default class TimeOffTypesSettingsModel extends MasterDataSettingsModel {
  get access() {
    return mainPageModel.canViewTimeOffTypes;
  }

  get _canAddItem(): boolean {
    return mainPageModel.canAddTimeOffTypes;
  }

  get _canEditItem(): boolean {
    return mainPageModel.canEditTimeOffTypes;
  }

  get _canDeleteItem(): boolean {
    return mainPageModel.canDeleteTimeOffTypes;
  }

  getTrackingSummary(v: ITimeOffType): string {
    if (!v.id) return 'Tracking';

    const summary: string[] = [];
    if (v.trackingAmounts) summary.push('Track Amounts');
    if (v.trackingUnits) summary.push('Track Units');

    return summary.length ? `${summary.join(', ')}` : '«none»';
  }

  getWithdrawalReasonSummary(v: ITimeOffType): string {
    if (!v.id) return 'Withdrawal Reasons';

    return v.withdrawalReasons ? `${v.withdrawalReasons.map((r: ITimeOffType) => r.name).join(', ')}` : '«none»';
  }

  getAccrualReasonSummary(v: ITimeOffType): string {
    if (!v.id) return 'Accrual Reasons';

    return v.accrualReasons ? `${v.accrualReasons.map((r: ITimeOffType) => r.name).join(', ')}` : '«none»';
  }

  constructor() {
    super('Time Off Type', 'timeofftypes', timeoffTypeDialogModel, [
      { label: 'Tracking', get: (v: ITimeOffType) => this.getTrackingSummary(v), set: defaultSetter('Tracking') },
      {
        label: 'Withdrawal Reasons',
        get: (v: ITimeOffType) => this.getWithdrawalReasonSummary(v),
        set: defaultSetter('Withdrawal Reasons'),
      },
      {
        label: 'Accrual Reasons',
        get: (v: ITimeOffType) => this.getAccrualReasonSummary(v),
        set: defaultSetter('Accrual Reasons'),
      },
    ]);
    this.EditPanelFormView = TimeOffTypesEditPanelFormView;
  }
  protected async _load(filter: { search?: string }, sort?: TimeOffTypeSort) {
    const results = await DataQueries.getTimeOffTypes(
      TimeOffTypeSchema,
      filter,
      sort,
      this.paging.itemsPerPage,
      this.paging.currentPage,
    );
    this.setItems(results.data);
    return results;
  }
}
